import { Icon } from '@smg-real-estate/domus';

import { Characteristics } from '@smg-real-estate/hg-rets-schema';

interface FurnishingField {
  name: keyof Characteristics;
  icon: Icon;
}
export const allowedFurnishingFields: FurnishingField[] = [
  { name: 'arePetsAllowed', icon: Icon.Pets },
  { name: 'hasBalcony', icon: Icon.Balcony },
  { name: 'hasGarage', icon: Icon.Garage },
  { name: 'hasElevator', icon: Icon.Elevator },
  { name: 'hasLakeView', icon: Icon.View },
  { name: 'hasMountainView', icon: Icon.View },
  { name: 'hasNiceView', icon: Icon.View },
  { name: 'hasParking', icon: Icon.Parking },
  { name: 'hasSwimmingPool', icon: Icon.Pool },
  { name: 'hasTumbleDryer', icon: Icon.Check },
  { name: 'hasWashingMachine', icon: Icon.WashingMachine },
  { name: 'isMinergieCertified', icon: Icon.Minergie },
  { name: 'isChildFriendly', icon: Icon.Children },
  { name: 'isQuiet', icon: Icon.Quiet },
  { name: 'isWheelchairAccessible', icon: Icon.Accessible },
];
